import { Bell, Gear, Key, Plugs, ShieldCheck } from "@phosphor-icons/react";
import { m } from "@plannello/i18n/messages";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SubNav } from "@/components/shell/SubNav";

export const Route = createFileRoute("/_app/settings")({ component: SettingsLayout });

/** Personal settings: a secondary rail (tabs row on small screens) next to the section the URL names. */
function SettingsLayout() {
  return (
    <div className="flex min-h-full flex-col lg:flex-row">
      <SubNav
        label={m.set_nav_label()}
        groups={[
          {
            items: [
              { to: "/settings", label: m.set_nav_general(), icon: Gear, exact: true },
              { to: "/settings/notifications", label: m.set_nav_notifications(), icon: Bell },
              { to: "/settings/security", label: m.set_nav_security(), icon: ShieldCheck },
              { to: "/settings/tokens", label: m.set_nav_tokens(), icon: Key },
              { to: "/settings/claude", label: m.set_nav_claude(), icon: Plugs },
            ],
          },
        ]}
      />
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
